import React from 'react';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const ReportCasesNewForm = () => {
  return (
    <div className=" mt-5">
      <h2 className="text-left mb-4" style={{ color: '#343a40' }}>Report Cases New</h2>
      <Form 
        action="/lab/reports/view/report/cases-new" 
        method="get" 
        acceptCharset="utf-8"
        className="p-4 border rounded shadow-sm"
        style={{
          borderTop: '5px solid #007bff',
          maxWidth: '700px',
          overflowY: 'auto',
        }}
      >
        <Form.Group as={Row} controlId="cases-new-start-date">
          <Form.Label column sm={4} className="font-weight-bold">
            Creation Start Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              type="date" 
              name="start_date" 
              required 
              defaultValue="2024-08-26" 
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="cases-new-end-date">
          <Form.Label column sm={4} className="font-weight-bold">
            Creation End Date <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              type="date" 
              name="end_date" 
              required 
              defaultValue="2024-08-26" 
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="cases_new_group_by">
          <Form.Label column sm={4} className="font-weight-bold">
            Group by <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              as="select" 
              name="group_by" 
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            >
              <option value="">Account</option>
              <option value="user_entry">User entry</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="cases_new_estimated_value">
          <Form.Label column sm={4} className="font-weight-bold">
            Estimated Value <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              as="select" 
              name="estimated_value" 
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            >
              <option value="">Whole Case</option>
              <option value="procedures_attributes">Procedures and Attributes Only</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="report_cases_new_sales_procedure">
          <Form.Label column sm={4} className="font-weight-bold">
            Procedures
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              as="select" 
              name="procedure[]" 
              multiple 
              size="10" 
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            >
              <option value="316">1-7 ALIGNERS (DUAL ARCH)</option>
              <optgroup label="ACRYLIC DENTURES">
                <option value="259">CLEAR ACRYLIC DRILL GUIDE</option>
              </optgroup>
              {/* Add other options and optgroups as needed */}
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="cases_new_format">
          <Form.Label column sm={4} className="font-weight-bold">
            Format <span className="text-danger">*</span>
          </Form.Label>
          <Col sm={8}>
            <Form.Control 
              as="select" 
              name="format"
              style={{
                borderColor: '#ced4da',
                boxShadow: 'none',
                borderRadius: '0.25rem',
              }}
            >
              <option value="">On Screen</option>
              <option value="csv">CSV (Excel)</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Col sm={{ span: 8, offset: 4 }}>
            <Link to="/Addnewcase">
              <Button
                id="pay-per-task-submit"
                type="button"
                variant="primary"
                className="w-100 mt-2"
                style={{
                  backgroundColor: '#004aad',
                  borderColor: '#004aad',
                  marginTop: '10px',
                }}
              >
                Run
              </Button>
            </Link>
          </Col>
        </Form.Group>
      </Form>
      
    </div>
    
  );
};

export default ReportCasesNewForm;



// import React from 'react';
// import { Form, Button, Col, Row,} from 'react-bootstrap';
// import { Link } from "react-router-dom";


// const PatientAlertForm = () => {
//   return (
//     <div className=" mt-5">
    
//       <Form
//         action="/lab/reports/view/report/patient-alert"
//         method="get"
//         id="report_patient_alert"
//         style={{ width: '600px' }}
//         acceptCharset="utf-8"
//       >
//         <fieldset>
//           <legend>Parameters</legend>

//           <Form.Group as={Row} controlId="patient-alert-start-date">
//             <Form.Label column sm={4} title="Please choose a start date to report on">
//               Start Date <span className="form_required">*</span>
//             </Form.Label>
//             <Col sm={8}>
//               <Form.Control
//                 type="date"
//                 name="start_date"
//                 className="start_date large"
//                 required
//                 defaultValue="2024-08-27"
//               />
//             </Col>
//           </Form.Group>

//           <Form.Group as={Row} controlId="patient-alert-end-date">
//             <Form.Label column sm={4} title="Please choose an end date to report on">
//               End Date <span className="form_required">*</span>
//             </Form.Label>
//             <Col sm={8}>
//               <Form.Control
//                 type="date"
//                 name="end_date"
//                 className="end_date large"
//                 required
//                 defaultValue="2024-08-27"
//               />
//             </Col>
//           </Form.Group>

//           <Form.Group as={Row}>
//             <Col sm={4}>
//               <Form.Check
//                 type="checkbox"
//                 name="exclude_past_due"
//                 value="1"
//                 id="patient-alert-exclude-past-due"
//                 label="Exclude Past Due Cases?"
//                 title="Exclude cases that are past their delivery date"
//               />
//             </Col>
//           </Form.Group>

//           <Form.Group as={Row}>
//             <Col sm={4}>
//               <Form.Check
//                 type="checkbox"
//                 name="include_closed_cases"
//                 value="1"
//                 id="patient-alert-include-closed-cases"
//                 label="Include closed pre-invoiced cases?"
//                 title="Include cases that are closed but not yet invoiced"
//               />
//             </Col>
//           </Form.Group>

//           <Form.Group as={Row} controlId="patient-alert_color">
//             <Form.Label column sm={4}>
//               Pan color
//             </Form.Label>
//             <Col sm={8}>
//               <Form.Control as="select" name="color" title="Select a color" className="large">
//                 <option value="">All</option>
//                 <option value="black">black</option>
//                 <option value="blue">blue</option>
//                 <option value="brown">brown</option>
//                 <option value="cyan">cyan</option>
//                 <option value="green">green</option>
//                 <option value="lime">lime</option>
//                 <option value="magenta">magenta</option>
//                 <option value="maroon">maroon</option>
//                 <option value="orange">orange</option>
//                 <option value="purple">purple</option>
//                 <option value="red">red</option>
//                 <option value="yellow">yellow</option>
//               </Form.Control>
//             </Col>
//           </Form.Group>

//           <Form.Group as={Row} controlId="report_patient_alert_format">
//             <Form.Label column sm={4} title="Please choose a display format">
//               Format <span className="form_required">*</span>
//             </Form.Label>
//             <Col sm={8}>
//               <Form.Control as="select" name="format" title="Please choose a display format" className="large">
//                 <option value="">On Screen</option>
//                 <option value="csv">CSV (Excel)</option>
//               </Form.Control>
//             </Col>
//           </Form.Group>

//          <Form.Group as={Row}>
//            <Col sm={{ span: 8, offset: 4 }}>
//              <Link to="/Addpatient">
//                <Button
//                  id="pay-per-task-submit"
//                  type="button"
//                  variant="primary"
//                  className="w-100 mt-2"
//                  style={{
//                    backgroundColor: '#004aad',
//                    borderColor: '#004aad',
//                    marginTop: '10px',
//                  }}
//                >
//                  Run
//                </Button>
//              </Link>
//            </Col>
//          </Form.Group>
//         </fieldset>
//       </Form>
     
//     </div>
//   );
// };

// export default PatientAlertForm;
